import PropTypes from 'prop-types';

const ConnectionWarningIcon = ({ size, fill, ...other }) => (
  <div style={{ fontSize: size }} {...other}>
    <svg width="1em" height="1em" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M22.4963855,8 C29.3783133,8 35.1036145,13.0127505 36.3180723,19.5992714 C36.8385542,19.5409836 37.3012048,19.4826958 37.8216867,19.4826958 C43.4313253,19.4826958 48,24.0874317 48,29.7413479 C48,35.3952641 43.4313253,40 37.8216867,40 L37.8216867,40 L7.51807229,40 C3.35421687,40 0,36.6193078 0,32.4225865 C0,28.2258652 3.35421687,24.845173 7.51807229,24.845173 C7.92289157,24.845173 8.26987952,24.9034608 8.6746988,24.9617486 C8.50120482,24.0874317 8.38554217,23.154827 8.38554217,22.1639344 C8.38554217,14.3533698 14.6891566,8 22.4963855,8 Z M24.0214903,30.3862442 C22.3450495,30.3862442 21.0124939,31.7821166 21.0124939,33.5382142 C21.0124939,35.2492836 22.3450495,36.645156 24.0214903,36.645156 C25.6549455,36.645156 26.9875011,35.2492836 26.9875011,33.5382142 C26.9875011,31.7821166 25.6549455,30.3862442 24.0214903,30.3862442 Z M24.0214903,12.645156 C22.4740064,12.645156 20.8405512,14.1761129 21.0124939,15.797126 L21.0124939,15.797126 L22.0011641,25.1629797 C22.1301211,26.3337114 22.9038631,27.2793024 24.0214903,27.2793024 C25.0961319,27.2793024 25.8698738,26.3337114 25.9988308,25.1629797 L25.9988308,25.1629797 L26.9875011,15.797126 C27.1594437,14.1761129 25.5259885,12.645156 24.0214903,12.645156 Z"
        fill={fill}
        fillRule="nonzero"
      />
    </svg>
  </div>
);

ConnectionWarningIcon.propTypes = {
  size: PropTypes.string,
  fill: PropTypes.string,
};

ConnectionWarningIcon.defaultProps = {
  size: 'inherit',
  fill: 'currentColor',
};

export default ConnectionWarningIcon;
